export default class Api {
    static getUrl(url) {
        return process.env.VUE_APP_API_URL + url;
    }
    static getEsewaUrl(url) {
        return process.env.VUE_APP_ESEWA_URL + url;
    }
}